<template>
  <!-- 条件对话框：推送任务页里直接新建/编辑条件，省掉「去条件管理 → 建好 → 回来重选」
       的来回跳转。表单本体复用 ConditionForm，与条件管理页保持同一套逻辑。 -->
  <el-dialog
    :title="conditionId ? $t('autoPush.condEditTitle') : $t('autoPush.condNewTitle')"
    :visible.sync="innerVisible"
    width="720px"
    append-to-body
  >
    <!-- v-if 保证每次打开都是全新实例：表单内容与校验状态自然重置 -->
    <ConditionForm
      v-if="innerVisible"
      :condition-id="conditionId"
      @saved="$emit('saved', $event)"
      @cancel="innerVisible = false"
    />
  </el-dialog>
</template>

<script>
import ConditionForm from './ConditionForm.vue'

/**
 * 条件表单对话框（薄包装）
 *
 * props.visible 用 .sync 双向绑定；conditionId 为空 = 新建，有值 = 编辑。
 * 保存成功后把 { id, name } 透传给父组件，由父组件决定是否选中/刷新列表。
 */
export default {
  name: 'ConditionFormDialog',
  components: { ConditionForm },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    conditionId: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      }
    }
  }
}
</script>
